import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Imports globais para a biblioteca react-pdf
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
